module.exports = __webpack_public_path__ + "img/ad.0800877a.svg";